import { useToken } from "../../server/auth/use-token";
import { useClaims } from "../generic/hooks/use-claims";
import { createDesignHuddleProject, getDesignHuddlePreviewUrl } from "./design-huddle-sdk";
import { useDesignHuddleCallback } from "./use-design-huddle-callback";
import { copyImage, imageURL } from "./utils";

import type { CommsImage } from "../template-preview/generate-comms-context";

export function useCreateDesignHuddleProjectComms(): (commsImage: CommsImage) => Promise<{
  project_id: string;
  preview_url: string;
} | null> {
  const user = useClaims();
  const getToken = useToken();

  return useDesignHuddleCallback(
    [],
    async (
      commsImage?: CommsImage,
    ): Promise<{ project_id: string; preview_url: string } | null> => {
      if (!user || !commsImage) return null;

      let project_id: string;
      try {
        project_id = await createDesignHuddleProject({
          media_type: "digital",
          template_code: commsImage.templateCode,
          customizations: commsImage.customizations,
          page_number: commsImage.pageNumber,
        });
      } catch (error) {
        console.log(error);
        return null;
      }

      if (!project_id) return null;

      const dimensions =
        commsImage.imageType === "banner"
          ? { width: 1200, height: 400 }
          : { width: 1200, height: 1200 };
      let preview_url: string;
      try {
        preview_url = await getDesignHuddlePreviewUrl({
          template_code: commsImage.templateCode,
          customizations: commsImage.customizations,
          page_number: commsImage.pageNumber,
          ...dimensions,
        });
      } catch (error) {
        console.log(error);
        return null;
      }

      if (!preview_url) return null;

      try {
        await copyImage(getToken, preview_url, project_id);
      } catch (error) {
        console.error(error);
        return null;
      }

      return {
        project_id,
        preview_url: imageURL(user["http://changeengine.com/account_id"], project_id),
      };
    },
    [user],
  );
}
